module.exports = __webpack_public_path__ + "7c097155d4dff4160fe601aca2a6c319.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/unimpressed-18.png
// module id = 2252
// module chunks = 0